import cn from 'classnames';
import { useEffect, useState } from 'react';
import { IoMdHeartEmpty, IoMdHeart } from 'react-icons/io';
import Cookies from 'universal-cookie';

import { updateUserLists } from '../api/wave/users';
import { AuthFavoriteModal } from '../store/authModalShow';
import User from '../store/user';

import styles from './ListButton.module.scss';

export default function ListButton({ product, isProductDetails = false, isFloating = true }) {
  const [isFavorite, setIsFavorite] = useState(false);
  const [isSuggested, setIsSuggested] = useState(false);
  const [animate, setAnimate] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get('token');
  const tooltipFavorite = 'Κάνε κλικ στο εικονίδιο της καρδιάς για να προσθέσεις το προϊόν στα αγαπημένα σου!';
  const tooltipSuggested =
    'Η έξυπνη πρόταση μας, καθώς ψωνίζεις συχνά το συγκεκριμένο προϊόν! Κάνε κλικ στο εικονίδιο της καρδιάς εάν θέλεις να το προσθέσεις στα αγαπημένα σου!';
  const tooltipUnfavorite =
    'Εάν θέλεις να αφαιρέσεις το συγκεκριμένο προϊόν από τα αγαπημένα σου, κάνε κλικ στο εικονίδιο της καρδιάς';

  function onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    const user = User.getValue();
    if (!user?._id) {
      AuthFavoriteModal.update(true);
      return;
    }
    const action = isFavorite ? 'remove' : 'add';
    if (action === 'add') setAnimate(true);
    setIsFavorite(!isFavorite);
    updateFavorites(user, action);
  }

  async function updateFavorites(user, action) {
    const { sku } = product;
    const { authToken } = user;
    const { list: favoritesUpdated, error } = await updateUserLists(
      user._id,
      {
        action,
        products: [sku],
      },
      authToken || token
    );
    if (error) return;
    const { lists = [] } = user;
    const existingLists = lists.filter(l => l.type !== 'favorites');
    const updatedLists = [...existingLists, favoritesUpdated];
    User.setLists(updatedLists);
  }

  useEffect(() => {
    const lists$ = User.getLists().subscribe(lists => {
      const favorites = lists.find(v => v.type === 'favorites')?.products || [];
      const _isFavorite = favorites.some(f => f.sku === product.sku);
      setIsFavorite(_isFavorite);
      if (_isFavorite) return;

      const suggested = lists.find(v => v.type === 'suggested')?.products || [];
      const _isSuggested = suggested.some(f => f.sku === product.sku);
      setIsSuggested(_isSuggested);
    });

    return () => {
      lists$.unsubscribe();
    };
  }, []);

  return !isProductDetails ? (
    <button
      className={cn(styles.btn, { [styles.animation]: animate, [styles.floating]: isFloating })}
      onClick={onClick}
      onAnimationEnd={() => setAnimate(false)}
      data-cy="fav"
    >
      {isFavorite ? (
        <IoMdHeart className={styles.icon} title={tooltipUnfavorite} />
      ) : isSuggested ? (
        <div className={styles.iconSuggested} title={tooltipSuggested} />
      ) : (
        <IoMdHeartEmpty className={styles.icon} title={tooltipFavorite} />
      )}
    </button>
  ) : (
    <div className={styles.favoriteContainer}>
      <button
        className={cn(styles.favoriteBtn, { [styles.animation]: animate })}
        onClick={onClick}
        onAnimationEnd={() => setAnimate(false)}
      >
        {isFavorite ? (
          <IoMdHeart className={styles.icon} title={tooltipUnfavorite} />
        ) : (
          <IoMdHeartEmpty className={styles.icon} title={tooltipFavorite} />
        )}
      </button>
      {isFavorite ? (
        <p className={styles.favoritesText}>Αγαπημένο</p>
      ) : (
        <p className={styles.favoritesText}>Προσθήκη στα αγαπημένα</p>
      )}
    </div>
  );
}
